import WebCheckInTypes from './webCheckIn.types';

// Create Web Check-In Actions
export const createWebCheckInStart = (data: any) => ({
	type: WebCheckInTypes.CREATE_WEB_CHECK_IN_START,
	payload: data,
});

export const createWebCheckInSuccess = (data: any) => ({
	type: WebCheckInTypes.CREATE_WEB_CHECK_IN_SUCCESS,
	payload: data,
});

export const createWebCheckInFailure = (error: unknown) => ({
	type: WebCheckInTypes.CREATE_WEB_CHECK_IN_FAILURE,
	payload: error,
});

// Fetch today's attendance status
export const fetchTodayAttendanceStart = (payload: any) => ({
	type: WebCheckInTypes.FETCH_TODAY_ATTENDANCE_START,
	payload,
});

export const fetchTodayAttendanceSuccess = (payload: any) => ({
	type: WebCheckInTypes.FETCH_TODAY_ATTENDANCE_SUCCESS,
	payload,
});

export const fetchTodayAttendanceFailure = (error: unknown) => ({
	type: WebCheckInTypes.FETCH_TODAY_ATTENDANCE_FAILURE,
	payload: error,
});

// Regularize attendance actions
export const regularizeAttendanceStart = (payload: any) => ({
	type: WebCheckInTypes.REGULARIZE_ATTENDANCE_START,
	payload,
});

export const regularizeAttendanceSuccess = (payload: any) => ({
	type: WebCheckInTypes.REGULARIZE_ATTENDANCE_SUCCESS,
	payload,
});

export const regularizeAttendanceFailure = (error: unknown) => ({
	type: WebCheckInTypes.REGULARIZE_ATTENDANCE_FAILURE,
	payload: error,
});

// Response Management Actions
export const webCheckInResponseChanged = () => ({
	type: WebCheckInTypes.WEB_CHECK_IN_RESPONSE_CHANGED,
});

export const webCheckInResponseRestStart = () => ({
	type: WebCheckInTypes.WEB_CHECK_IN_RESPONSE_REST_START,
});
